import React from 'react'
import { Link } from 'react-router-dom'
import BoatOwnerAdd from './BoatOwnerAdd'

class BoatOwnerAddTab extends React.Component {
  state = {}

  componentDidMount() {
    if (
      this.props.match.params.boatOwner_id !== undefined &&
      this.props.match.params.boatOwner_id !== null &&
      this.props.match.params.boatOwner_id !== 0 &&
      this.props.match.params.boatOwner_id !== ''
    ) {
      this.setState({ boatOwner_id: this.props.match.params.boatOwner_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    {localStorage.getItem('waves_ad_role') === 'shop' ? (
                      <h4>Edit Profile</h4>
                    ) : (
                      <h4>{this.props.match.params.boatOwner_id ? 'Edit' : 'Add'} Owner</h4>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  {localStorage.getItem('waves_ad_role') === 'shop' ? (
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Edit Profile</li>
                    </ul>
                  ) : (
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/boat-Owner">Owner</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        {this.props.match.params.boatOwner_id ? 'Edit' : 'Add'} Owner
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    {/* <ul className="nav nav-tabs  tabs" role="tablist">
                      {this.state.language_data !== undefined &&
                      this.state.language_data !== []
                        ? this.state.language_data.map((language) => (
                            <li
                              className="nav-item"
                              key={language.id}
                              onClick={this.handleLanguage.bind(
                                this,
                                language.id
                              )}
                            >
                              <a
                                className={
                                  this.state.language_id === language.id
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                id={"language_" + language.id}
                                data-toggle="tab"
                                href={"#add_dealer_" + language.id}
                                role="tab"
                                aria-controls={"add_dealer_" + language.id}
                                aria-selected="true"
                              >
                                {language.name}{" "}
                              </a>
                            </li>
                          ))
                        : ""}
                    </ul> */}
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_dealer_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.boatOwner_id !== undefined &&
                        this.state.boatOwner_id !== null &&
                        this.state.boatOwner_id !== 0 &&
                        this.state.boatOwner_id !== '' ? (
                          <BoatOwnerAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            boatOwner_id={this.state.boatOwner_id}
                          />
                        ) : (
                          <BoatOwnerAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatOwnerAddTab
